import React from "react"
import PropTypes from "prop-types"
import { Box } from "@mui/material"

export const LayerType = {
  Koku: "kouku",
  Gyoseikai: "gyouseikai",
  RoadGrid: "roadgrid",
  Route: "route",
  HighlightRoute: "highlight_route",
  Yudoin: "yudoin",
  Pruning: "pruning",
  TreeCrown: "tree_crown",
  TollTree: "toll_tree",
  HedgeTree: "row_tree",
  GroundCover: "ground_cover",
}

export const LayerName = {
  Koku: "工区界",
  Gyoseikai: "行政界",
  RoadGrid: "道路図郭",
  Route: "路線",
  HighlightRoute: "見どころ路線",
  Yudoin: "誘導員が必要な路線",
  Pruning: "樹冠拡大タイプ",
  TreeCrown: "樹木・樹冠",
  TollTree: "樹木・高木",
  HedgeTree: "樹木・低木",
  GroundCover: "地被類",
}

const styles = {
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    "& label": {
      display: "flex",
      alignItems: "flex-start",
      gap: "6px",
      cursor: "pointer",
      lineHeight: 1,
    },
    "& input[type='radio']": {
      margin: 0,
      flexShrink: 0,
    },
  },
}

const MapControlLayerSelector = (props) => {
  return (
    <Box sx={{ ...styles.root, ...props.sx }}>
      <label>
        <input
          type="radio"
          name="layer-selector"
          onClick={(e) => props.onChange && props.onChange(null)}
        />
        なし
      </label>
      <label>
        <input
          type="radio"
          value={LayerType.Koku}
          name="layer-selector"
          onClick={(e) => props.onChange && props.onChange(LayerType.Koku)}
        />
        {LayerName.Koku}
      </label>
      <label>
        <input
          type="radio"
          value={LayerType.Gyoseikai}
          name="layer-selector"
          onClick={(e) => props.onChange && props.onChange(LayerType.Gyoseikai)}
        />
        {LayerName.Gyoseikai}
      </label>
      <label>
        <input
          type="radio"
          value={LayerType.RoadGrid}
          name="layer-selector"
          onClick={(e) => props.onChange && props.onChange(LayerType.RoadGrid)}
        />
        {LayerName.RoadGrid}
      </label>
      <label>
        <input
          type="radio"
          value={LayerType.Route}
          name="layer-selector"
          onClick={(e) => props.onChange && props.onChange(LayerType.Route)}
        />
        {LayerName.Route}
      </label>
      <label>
        <input
          type="radio"
          value={LayerType.HighlightRoute}
          name="layer-selector"
          onClick={(e) =>
            props.onChange && props.onChange(LayerType.HighlightRoute)
          }
        />
        {LayerName.HighlightRoute}
      </label>
      <label>
        <input
          type="radio"
          value={LayerType.Yudoin}
          name="layer-selector"
          onClick={(e) => props.onChange && props.onChange(LayerType.Yudoin)}
        />
        {LayerName.Yudoin}
      </label>
      <label>
        <input
          type="radio"
          value={LayerType.Pruning}
          name="layer-selector"
          onClick={e => props?.onChange(LayerType.Pruning)}
        />
        {LayerName.Pruning}
      </label>
      <label>
        <input
          type="radio"
          value={LayerType.TreeCrown}
          name="layer-selector"
          onClick={e => props?.onChange(LayerType.TreeCrown)}
        />
        {LayerName.TreeCrown}
      </label>
      <label>
        <input
          type="radio"
          value={LayerType.TollTree}
          name="layer-selector"
          onClick={e => props?.onChange(LayerType.TollTree)}
        />
        {LayerName.TollTree}
      </label>
      <label>
        <input
          type="radio"
          value={LayerType.HedgeTree}
          name="layer-selector"
          onClick={e => props?.onChange(LayerType.HedgeTree)}
        />
        {LayerName.HedgeTree}
      </label>
      <label>
        <input
          type="radio"
          value={LayerType.GroundCover}
          name="layer-selector"
          onClick={e => props?.onChange(LayerType.GroundCover)}
        />
        {LayerName.GroundCover}
      </label>
    </Box>
  )
}

MapControlLayerSelector.propTypes = {
  onChange: PropTypes.func,
  sx: PropTypes.object,
}

export default MapControlLayerSelector
